import { action } from '@ember/object';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { later } from '@ember/runloop';
import config from 'frontend/config/environment';
import { service } from '@ember/service';
import type FastbootService from 'ember-cli-fastboot';
import { getOwner } from '@ember/application';
import type ApplicationAdapter from 'frontend/adapters/application';

export default class HeaderBarComponent extends Component {
  @service declare fastboot: FastbootService;
  @tracked showWebComponent: boolean = true;

  get url() {
    const adapter = getOwner(this).lookup(
      'adapter:application'
    ) as ApplicationAdapter;
    return adapter.host;
  }

  get wpUrl() {
    return config.wpUrl;
  }

  get frontUrl() {
    return config.frontUrl;
  }

  get noRequestForMenuWhenTest() {
    return config.environment === 'test' ? 'true' : false;
  }

  @action
  triggerRerender() {
    // This function allows us to rerender the widget svelte that are not reactive when data changes (in this case, we're updating the widget when a current user is set)
    this.showWebComponent = false;
    later(
      this,
      () => {
        this.showWebComponent = true;
      },
      100
    );
  }
}
